// extracted by mini-css-extract-plugin
export default {"contactInfo":"ContactInfo_contactInfo__iG5YV","businessPage":"ContactInfo_businessPage__nroUb","contactItems":"ContactInfo_contactItems__ufJMJ"};